import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Header, Button, Paragraph, ErrorMark, MortgageRegulationContacts } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import * as CONST from "../../../app/constants";
import * as UTILS from "../../../app/utils";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";

export const ConfirmPrincipalBroker = (props) => {
    const dispatch = useDispatch();
    const { agencyApplication }  = useSelector(agencyApplicationSelector);

    const [notQualified, setNotQualified] = useState(false);

    let userName = agencyApplication?.contactName;

    const handleNext = (answer) => {
        if(answer) {
            let nextUrl = CONST.ROUTE_PATH.RJSC_DETAIL_RENEW_REVIEW;

            dispatch(
                push({
                  pathname: UTILS.replaceUrlParams(
                    nextUrl,
                    CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
                    CONST.APPLICATION_MODE_RENEW
                  )
                })
              );
        }
    }

    return (
        <div className="container">
            <TopNavigationBar {...props} />
            
            <div className="row bottomMarginMedium">
                <div className="col-xs-12 col-lg-11">
                    <Header
                        id="mra-renewal-confirm-pb-header"
                        header="Are you the Principal Broker?"
                    />
                </div>
                <div className="col-xs-12 col-lg-11 topMarginMedium">
                    <Paragraph
                        id="mra-renewal-confirm-pb-text"
                        text={[
                        `<b> ${userName} </b>, before you renew, you need to <b>confirm</b> that you are still the <b>Principal Broker</b> for the brokerage. The Principal Broker must be licensed mortgage broker who is a director, partner, officer or sole proprietor at the company.`,
                        "The <b>Principal Broker is responsible</b> for renewing the brokerage, mortgage broker and associate mortgage broker licences.",
                        "if you are <b>no longer the Principal Broker</b>, you must appoint a new principal broker before submitting renewals for the brokerage, mortgage brokers and associates.",
                        "<b>Are you still the Principal Broker?</b>"
                        ]}
                    />
                </div>
            </div>
            
            <div className="row bottomMarginMedium">
                <div className="col-xs-4">
                    <Button
                        className="btn-lg btn-default"
                        buttonType={"regular_primary"}
                        text={"Yes, continue with licence renewal"}
                        onClick={() => {
                            handleNext(true);
                        }}
                    />
                </div>
                <div className="col-xs-4">
                    <Button
                        className="btn-lg btn-default"
                        buttonType={"regular_link"}
                        text={"No, appoint a new Principal Broker"}
                        onClick={() => {
                            setNotQualified(true);
                        }}
                    />
                    {notQualified  && ErrorMark()}
                    {notQualified && 
                        <MortgageRegulationContacts message="If you do not meet the qualifications you must assign
                         a different Principal Broker who meets the qualifications.
                          To assign a different Principal Broker, contact Business Licensing:" />
                    }
                </div>
            </div>
        </div>
    )
}
